import _taggedTemplateLiteral from "D:\\repos\\finam.portal.onboarding\\NewbiePortal\\newbie_app\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/taggedTemplateLiteral";

var _templateObject, _templateObject2;

import styled from 'styled-components';
import Link from '../../Core/Link';
export var Rules = styled.div(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  margin-top: 28px;\n"])));
export var BackLink = styled(Link)(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n  margin-top: 32px;\n"])));